import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import ReduxDrawer from 'containers/DrawerManager/ReduxDrawer';
import { updateCustomerNotes, closeCustomerNotesDrawer } from '../actions';
import CustomerNotesForm from './CustomerNotesForm';
import { EDIT_CUSTOMER_NOTES } from '../BillingInformation/constants';

const CustomerNotesDrawer = () => {
  const dispatch = useDispatch();
  const handleHideForm = () => dispatch(closeCustomerNotesDrawer());
  const handleFormSubmit = useCallback(
    ({
      locationType,
      locationDescription,
      otherText,
      additionalInstructions,
    }) =>
      dispatch(
        updateCustomerNotes({
          noteType: locationType,
          note: otherText || locationDescription,
          additionalInstructions,
        }),
      ),
  );

  return (
    <ReduxDrawer
      WrappedComponent={(props) => (
        <CustomerNotesForm onSubmit={handleFormSubmit} {...props} />
      )}
      drawerKey={EDIT_CUSTOMER_NOTES}
      drawerProps={{
        headerTitle: 'Delivery Instructions',
      }}
      props={{
        onClose: handleHideForm,
      }}
    />
  );
};

export default CustomerNotesDrawer;
